<template>
  <div>
    <v-layout row justify-center>
      <v-dialog
        v-model="dialog"
        persistent
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-tooltip v-on="on" left>
            <template v-slot:activator="{ on }">
              <v-btn
                v-if="true"
                class="mt-5 mr-2"
                v-on="on"
                absolute
                dark
                fab
                top
                right
                color="primary"
                @click="accountabilityDialogShowHide"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </template>
            <span>Nova prestação de conta</span>
          </v-tooltip>
        </template>
        <v-card>
          <v-toolbar dark color="primary">
            <v-btn icon dark @click="accountabilityDialogShowHide">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>{{
              setTitleForm(accountabilityDialogEditData.representative_id)
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                v-if="!accountabilityDialogEditData.viewForm"
                :loading="loadingBtn"
                dark
                flat
                @click="saveData"
                >Salvar</v-btn
              >
            </v-toolbar-items>
          </v-toolbar>
          <v-tabs
            id="accountabilityTab"
            v-model="active"
            color="white"
            slider-color="primary"
            class="pt-2 px-3"
          >
            <v-tab
              v-for="tab in tabs"
              show-arrows
              :replace="true"
              :key="tab.id"
              :value="tab.id"
              :disabled="tab.id > 0 && blockTabs"
              class="grey--text text--darken-1"
              >{{ tab.name }}</v-tab
            >
            <v-tab-item :key="0" class="ma-5">
              <AccountabilityForm
                ref="frmAccountability"
                :dialog="dialog"
                :data="accountabilityDialogEditData"
                :condominiumsList="condominiumsList"
                :viewForm="accountabilityDialogEditData.viewForm"
              />
            </v-tab-item>
            <v-tab-item :key="1" class="ma-5">
              <RevisinDatesGrid
                :revision_dates="
                  accountabilityDialogEditData.accountabilityFolders
                "
                :uploadDialog="openDialogForm"
                :sendFile="sendFile"
                :viewForm="accountabilityDialogEditData.viewForm"
              />
            </v-tab-item>
            <v-tab-item :key="2" class="ma-5 px-5">
              <UploadAccountabilityFiles
                v-if="!accountabilityDialogEditData.viewForm"
                :sendFile="(data) => sendFile(data)"
                margin="none"
                :dialog="uploadDialog"
                uploadType="attchment"
                :openForm="() => openDialogForm('upLoad')"
                :closeForm="() => closeDialogForm('upLoad')"
                :idToEdit="accountabilityDialogEditData.id"
                :viewForm="accountabilityDialogEditData.viewForm"
              />
              <GeneralFiles
                :confirmDelGeneralFiles="confirmDelGeneralFiles"
                :importedFiles="accountabilityDialogEditData.files"
                :editItem="(id) => openDialogForm('upLoad', id)"
                :viewForm="accountabilityDialogEditData.viewForm"
              />
            </v-tab-item>
          </v-tabs>
          <!-- <v-divider></v-divider> -->
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import axios from "axios";
import * as moment from "moment";
import AccountabilityForm from "./AccountabilityForm";
import UploadAccountabilityFiles from "../common/UploadFile";
import RevisinDatesGrid from "./RevisionDatesGrid";
import GeneralFiles from "./GeneralFiles";
export default {
  props: {
    dialog: Boolean,
    accountabilityDialogShowHide: Function,
    accountabilityDialogEditData: Object,
    condominiumsList: Array,
    getAccountability: Function,
    editItem: Function,
  },
  components: {
    AccountabilityForm,
    GeneralFiles,
    RevisinDatesGrid,
    UploadAccountabilityFiles,
  },
  watch: {
    dialog(v) {
      if (v) {
        // console.log(this.accountabilityDialogEditData.id);
        const tabs = document.querySelectorAll(
          "#accountabilityTab .v-tabs__item"
        );
        tabs[1].click();
        tabs[0].click();
        setTimeout(() => {
          if (this.$refs.frmAccountability.formData.representative_id) {
            this.blockTabs = false;
          }
        }, 200);
      } else {
        this.updatedEditId = "";
        this.blockTabs = true;
        this.getAccountability();
      }
    },
  },
  methods: {
    sendFile(data) {
      let USER_TOKEN = localStorage.getItem("token");
      let AuthStr = "Bearer ".concat(USER_TOKEN);
      let url = "";
      let method = "";
      let formData = new FormData();
      if (this.lineObject) {
        url = "/api/accountability_folder/update";
        method = "post";
        formData.append(
          "accountabilities_id",
          this.lineObject["accountabilities_id"]
        );
        formData.append("id", this.lineObject["id"]);
        formData.append("reference_month", this.lineObject["reference_month"]);
        formData.append("file_month", data["file"]);
        formData.append("file_name", data["fileName"]);
      } else {
        //accountability_file/store - POST; accountability_file/{Id} - GET; accountability_file/destroy/{Id} - DELETE
        url = "/api/accountability_file/store";
        method = "post";
        formData.append("file_name", data["fileName"]);
        formData.append("accountabilities_id", data.id);
        formData.append("file", data.file);
      }

      this.$store.commit("showLoader", {
        circle: true,
      });

      axios.defaults.baseURL =
        process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV;
      axios[method](url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: AuthStr,
        },
      })
        .then((resp) => {
          this.$store.commit("hideLoader");
          let obj = {
            message: "Upload realizado com sucesso!",
            title: "Sucesso",
            callback: (_) => {
              if (!this.lineObject) {
                if (!this.accountabilityDialogEditData.files) {
                  this.accountabilityDialogEditData.files = [];
                }
                this.accountabilityDialogEditData.files.push(resp.data);
              } else {
                var index = this.accountabilityDialogEditData.accountabilityFolders.findIndex(
                  (acc) => acc.id == resp.data.id
                );

                resp.data.analyze_manager_send = moment(
                  resp.data.analyze_manager_send
                ).format("DD/MM/YYYY");

                resp.data.analyze_sindication_approve = moment(
                  resp.data.analyze_sindication_approve
                ).format("DD/MM/YYYY");

                resp.data.analyze_sindication_send = moment(
                  resp.data.analyze_sindication_send
                ).format("DD/MM/YYYY");

                resp.data.completed_by_sindication = moment(
                  resp.data.completed_by_sindication
                ).format("DD/MM/YYYY");

                this.accountabilityDialogEditData.accountabilityFolders.splice(
                  index,
                  1,
                  resp.data
                );
              }
              setTimeout(() => {
                this.uploadDialog = false;
              }, 100);
              //this.initialize();
            },
            type: "success",
            btConfirm: { name: "Fechar", show: true },
            btCancel: { name: "Fechar", show: false },
          };
          this.$store.commit("confirmMessage/showConfirmMessage", obj);
        })
        .catch((error) => {
          let paramModal = {};
          paramModal.message = error.response
            ? error.response.data.errors
              ? Object.values(error.response.data.errors).join("<br>")
              : error.response.data.message
            : "Contate o administrador do sistema";
          paramModal.title = "Ocorreu erro";
          paramModal.type = "error";
          paramModal.callback = null;
          paramModal.btConfirm = {
            name: "Ok",
            show: true,
          };
          paramModal.btCancel = {
            show: false,
          };
          this.$store.commit("hideLoader");
          this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
        });

      // let obj = {
      //   url: "/api/accountability_folder/update",
      //   query: formData,
      //   method: "put",
      // };
      // this.$store.dispatch("request/doRequest", obj).then((response) => {
      //   if (!response) {
      //     return;
      //   }
      // });
    },
    openDialogForm(type, id, obj) {
      if (type == "upLoad") {
        this.idToEdit = id ? id : 0;
        this.uploadDialog = true;
        this.lineObject = obj;
        return;
      }
    },
    closeDialogForm(type) {
      if (type == "upLoad") {
        this.lineObject = null;
        this.uploadDialog = false;
        return;
      }
    },
    confirmDelGeneralFiles(data) {
      //console.log(this.accountabilityDialogEditData.files, data);
      let obj = {
        message: `Você deseja excluir o arquivo "${data.file_name}"?`,
        title: "Excluir arquivo",
        callback: (_) => {
          this.delGeneralFiles(data);
        },
        type: "warning",
        btConfirm: { name: "Sim", show: true },
        btCancel: { name: "Não", show: true },
      };
      this.$store.commit("confirmMessage/showConfirmMessage", obj);
    },
    delGeneralFiles(data) {
      let obj = {
        url: "/api/accountability_file/destroy/" + data.id,
        query: "",
        method: "delete",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }
        let opts = {
          message: `Condomínio removido com sucesso`,
          type: "success",
        };
        this.$store.commit("showAlert", opts);
        var index = this.accountabilityDialogEditData.files.findIndex(
          (file) => file.id === data.id
        );
        this.accountabilityDialogEditData.files.splice(index, 1);
        console.log(index);
        //this.getAccountability();
      });
    },
    saveData() {
      // this.$parent.$parent.$refs.searchDocs.condominiums;
      //this.loadingBtn = true;
      if (!this.$refs.frmAccountability.$refs.AccountabilityForm.validate()) {
        return;
      }
      let editId;

      if (
        this.$refs.frmAccountability.formData.representative_id ||
        this.updatedEditId
      ) {
        editId = true;
      } else {
        editId = false;
      }

      let url = editId
        ? "/api/accountability/update"
        : "/api/accountability/store";
      let query = this.$refs.frmAccountability.formData;
      if (this.updatedEditId) {
        query.id = this.updatedEditId;
      }
      //console.log('pomba')
      let obj = {
        url: url,
        query: query,
        method: editId ? "put" : "post",
      };
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response) {
          return;
        }
        let accability = response.data[0];
        let newaccountability = accability.accountability_folders.map(
          (date) => {
            date.analyze_sindication_send
              ? (date.analyze_sindication_send = moment(
                  date.analyze_sindication_send
                ).format("DD/MM/YYYY"))
              : date.analyze_sindication_send;

            date.analyze_sindication_approve
              ? (date.analyze_sindication_approve = moment(
                  date.analyze_sindication_approve
                ).format("DD/MM/YYYY"))
              : date.analyze_sindication_approve;

            date.analyze_manager_send
              ? (date.analyze_manager_send = moment(
                  date.analyze_manager_send
                ).format("DD/MM/YYYY"))
              : date.analyze_manager_send;

            date.completed_by_sindication
              ? (date.completed_by_sindication = moment(
                  date.completed_by_sindication
                ).format("DD/MM/YYYY"))
              : date.completed_by_sindication;
            // console.log(date);
            if (
              date.analyze_manager_send &&
              date.analyze_sindication_approve &&
              date.analyze_sindication_send &&
              date.completed_by_sindication
            ) {
              date.closedMonth = true;
            }
            return date;
          }
        );
        //console.log(newaccountability);
        this.updatedEditId = response.data[0].id;
        accability.accountabilityFolders = [...newaccountability];
        this.editItem(accability, "save");
        this.blockTabs = false;
        let opts = {
          message: "Prestação de contas salva",
          type: "success",
        };
        this.$store.commit("showAlert", opts);
      });
    },
    setTitleForm(id) {
      let returnTitle;
      if (id) {
        returnTitle = "Editar prestação de conta";
      } else {
        returnTitle = "Nova prestação de conta";
      }
      if (this.accountabilityDialogEditData.viewForm) {
        returnTitle = "Visualização";
      }
      return returnTitle;
    },
  },
  data() {
    return {
      updatedEditId: "",
      lineObject: null,
      uploadDialog: false,
      idToEdit: null,
      blockTabs: true,
      loadingBtn: false,
      active: 0,
      tabs: [
        { id: "0", name: "Informações gerais" },
        {
          id: 1,
          name: "Datas e revisões",
        },
        {
          id: 2,
          name: "Arquivos enviados",
        },
      ],
      id: "",
    };
  },
};
</script>

<style>
</style>